import { useRef } from "react";

import { AppShell } from "@chef/feature-app-shell";
import {
  BlockContent,
  ITellAFriendCompetition,
  ITellAFriendDefault,
  useTellAFriendCompetitionData,
} from "@chef/feature-sanity";

import { TellAFriendConfirmation } from "../../components/TellAFriend/TellAFriendConfirmation";
import { TellAFriendLayout } from "../../components/TellAFriend/TellAFriendLayout";
import { useScrollToCompetitionInformation } from "../../hooks/useScrollToCompetitionInformation";

import { intl } from "./ConfirmationTellAFriendPage.Intl";

interface ConfirmationTellAFriendPageProps {
  tellAFriendCompetition: ITellAFriendCompetition;
  tellAFriendDefault: ITellAFriendDefault;
}

export const ConfirmationTellAFriendPage = ({
  tellAFriendCompetition,
  tellAFriendDefault,
}: ConfirmationTellAFriendPageProps) => {
  const [tellAFriendCompetitionData] = useTellAFriendCompetitionData(
    tellAFriendCompetition,
  );

  const scrollRef = useRef<HTMLDivElement>(null);

  const { openCompetitionInformation } = useScrollToCompetitionInformation({
    scrollRef,
  });
  const { heading } = tellAFriendDefault;

  return (
    <AppShell title={intl.CONFIRMATION}>
      <AppShell.Header />
      <AppShell.AccountPausedBanner />
      <AppShell.OldVippsBanner />

      <AppShell.Meta />

      <AppShell.Main className="flex justify-center">
        <BlockContent body={heading} />
        <TellAFriendLayout
          tellAFriendCompetition={tellAFriendCompetition}
          competitionInformationRef={scrollRef}
        >
          {tellAFriendCompetitionData && (
            <TellAFriendConfirmation
              competitionContent={tellAFriendCompetitionData}
              onScrollToCompetitionInformationClicked={
                openCompetitionInformation
              }
            />
          )}
        </TellAFriendLayout>
      </AppShell.Main>

      <AppShell.Footer minified />
      <AppShell.TabBar />
    </AppShell>
  );
};
